<template>
  <div>
           <vue-headful
            title="Order History - Girish Jewellers"
            description="Order History, girish jewellers is the jewellery shop having varity of golden and silver ornament designs of products like bangles, bracelets, golden sets,pandent set, rings, wedding bands in rajkot gujarat india."
            keywords= "golden ornaments, silver ornaments, bangles, bracelets, golden sets,pandent set, rings, wedding bands, online order,best, purity, jewellery shop, in rajkot gujarat india"
            abstract = "Golden and silver ornaments online orering and selling shop"
            author = "Girish Jewellers"
            copyright = "Girish Jewellers"
            robots = "INDEX,FOLLOW"
        />    
    <LeftPanel msg="Welcome to Your Vue.js App"/>
    <div>
      <div class="page-box">
        <div class="page-box-content">
          <div id="header-area">          
          <TopHeader msg="Welcome to Your Vue.js App"/>
          <Header msg="Welcome to Your Vue.js App"/>
          </div>
            <section id="main">
                <div class="container"> 
<div class="title-box" v-if="!isMobile()">
<h1 class="title">Order History</h1>
</div>
<div class="title-box no-margin" v-if="isMobile()">
<h3 class="title">Order History</h3>
</div>
			
<div class="clearfix"></div>

            <div class="table-box">
                <table id="shopping-cart-table"  class="shopping-cart-table table table-bordered table-striped">
                <thead v-if="!isMobile()">
                <tr>
                    <th class="action"></th>
                    <th class="">Order No.</th>
                    <th class="">Order Date</th>
                    <th class="">Order Status</th>
                </tr>
                </thead>
               <tbody v-if="!isMobile()">
                
                
                  <tr v-if="results.length<=0">
                      <td colspan="4">You have not purchased anything yet!<br><router-link to="/account"> Click here to go back.</router-link></td>
                  </tr>
                    <tr v-for="result in results" :key="result.id">
                <td class="td-images">
                  <router-link :to="'order-view/?oid=' + result.id">View</router-link>
                </td>
                <td class="td-name">
                    <h2 class="product-name">
                    {{result.id}}
                    </h2>
                </td>

                <td class="td-qty">
                  <span class="price">{{result.order_date}}</span>
                </td>
                <td class="td-qty">
                  <span class="price">{{result.order_status}}</span>
                </td>
                    </tr>
                                    </tbody>
                </table><!-- .shopping-cart-table -->
               
                <div v-if="isMobile()">
                    <div class="span4 content-block bottom-padding frame-shadow-raised" style="text-align:center;" v-if="results.length<=0">
                         <div class="header-box" style="text-align:left;" to="javascript:void(0);">
                           You have not purchased anything yet! <br><router-link to="/account"> Click here to go back.</router-link>
                         </div>

                    </div>                                  
                    <router-link v-for="result in results" :key="result.id" class="header-box" style="text-align:left;width:100%" :to="'/order-view/?oid=' + result.id">
                    <div   class="span4 text-small content-block listview" style="text-align:left;margin-top:0px;margin-bottom:2px">
                        
                          <strong>Order No.: </strong>#{{result.id}}<br>
                          <strong>Date:</strong> {{result.order_date}} <br>
                          <strong>Order Status:</strong> {{result.order_status}}
                        

                    </div>                
                    </router-link>
                </div>
            </div>
              <div id="car-bottom" class="row">
              </div>
            
              </div>
            <div class="clearfix"></div>  
            </section>         
        <Footer msg="Welcome to Your Vue.js App" v-if="isMobile()"/>
        
        </div><!-- .page-box-content -->
        </div><!-- .page-box -->
     </div>
      <FooterWeb msg="Welcome to Your Vue.js App" v-if="!isMobile()"/>
    </div>
</template>

<script>
// @ is an alias to /src
import $ from 'jquery'
import LeftPanel from '@/components/LeftPanel.vue'
import TopHeader from '@/components/TopHeader.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import FooterWeb from '@/components/FooterWeb.vue'
import Common from '@/common.js'
import {mapGetters, mapActions} from "vuex";
import vueHeadful from 'vue-headful';


export default {
  name: 'OrderHistory',
  components: {
    vueHeadful,
    LeftPanel,
    TopHeader,
    Header,
    Footer,
    FooterWeb
    },created(){
        this.getSession;
    },
    computed:mapGetters(["Session","Orders"]),
    watch:{
        Session(newValue) {
          if(newValue.is_login){
              this.getOrders(newValue.user_id);
            }
          else{
              this.$router.push('/login')
            } 
          },
        Orders(newValue) {this.get_orders_response(newValue); }
    },
    mounted:function(){
      this.loadOnMount();
    },
    data:function(){
        return {results: {} };
    },
    methods:{
      ...mapActions(["getSession","getOrders"]),
      isMobile:function(){
   return Common.isMobile();
},
get_orders_response:function(response)
{ 
    //var rdata = JSON.parse(response);
    this.results = response;

},
loadOnMount: function() {
      
      Common.stopAjaxLoader();
      this.getSession();
      $.get('js/main.js', function(data) {
        eval(data);
   //process text file line by line
   //$('#div').html(data.replace('n',''));
        });
    }

  }
    
}
</script>